export default __webpack_public_path__ + "static/DSC_0221-38cbb1a2943afaee8c04f581230a74f4.jpg";